export default "__VITE_ASSET__DEBJGW_p__"